import { Typography } from '@mui/material';
import { ColorPalette } from 'shared/consts/colorPalette';
import { format } from 'date-fns';
import { Column } from 'shared/ui/tables/_common/types';
import { TableTranslationLabel } from 'shared/ui/tables/_common/ui/TableTranslationLabel';
import { SubscriptionType } from 'entities/Subscriptions/types';

export const SubscriptionsTableColumns: Array<Column<SubscriptionType>> = [
	{
		field: 'duration',
		commonCellSettings: {
			style: {
				width: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="file_storage_duration" />,
		},
		bodyCellSettings: {
			renderCell: (subscription) => {
				return subscription?.autoRemovePeriod?.key ? (
					<>
						{subscription?.autoRemovePeriod?.amount}{' '}
						<TableTranslationLabel path={`shared_texts.${subscription?.autoRemovePeriod?.key}`} />
					</>
				) : (
					'-'
				);
			},
		},
	},
	{
		field: 'amountOfCoUsers',
		commonCellSettings: {
			style: {
				width: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="co_users" />,
		},
		bodyCellSettings: {
			prepareField: (subscription) => `${subscription?.totalCousers}`,
		},
	},
	{
		field: 'amountOfFiles',
		commonCellSettings: {
			style: {
				width: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="imported_files" />,
		},
		bodyCellSettings: {
			prepareField: (subscription) => `${subscription?.totalFiles}`,
		},
	},
	{
		field: 'totalExtraPages',
		commonCellSettings: {
			style: {
				width: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="total_extra_pages" />,
		},
		bodyCellSettings: {
			renderCell: (subscription) => subscription?.totalExtraPages ?? '-',
		},
	},
	{
		field: 'totalPages',
		commonCellSettings: {
			style: {
				width: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="total_pages" />,
		},
		bodyCellSettings: {
			prepareField: (subscription) => `${subscription?.totalPages}`,
		},
	},
	{
		field: 'subscriptionDateStart',
		commonCellSettings: {
			style: {
				width: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="period_start" />,
		},
		bodyCellSettings: {
			renderCell: (subscription) => {
				return subscription?.currentPeriodStart ? (
					<Typography variant={'body2'} component={'span'} color={ColorPalette.astronaut}>
						{format(new Date(subscription.currentPeriodStart), 'dd/MM/yyyy')}
					</Typography>
				) : (
					<Typography variant={'body2'} component={'span'} color={ColorPalette.baliHai}>
						{'--/--/----'}
					</Typography>
				);
			},
		},
	},
	{
		field: 'subscriptionDateEnd',
		commonCellSettings: {
			style: {
				width: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="period_end" />,
		},
		bodyCellSettings: {
			renderCell: (subscription) => {
				return subscription?.currentPeriodEnd ? (
					<Typography variant={'body2'} component={'span'} color={ColorPalette.astronaut}>
						{format(new Date(subscription.currentPeriodEnd), 'dd/MM/yyyy')}
					</Typography>
				) : (
					<Typography variant={'body2'} component={'span'} color={ColorPalette.baliHai}>
						{'--/--/----'}
					</Typography>
				);
			},
		},
	},
];
